/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_EyebrowInputs */

const es_landing_law_eyebrow = /** @type {(inputs: Landing_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que casi nadie sabe todavía`)
};

const gl_landing_law_eyebrow = /** @type {(inputs: Landing_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que case ninguén sabe aínda`)
};

const en_landing_law_eyebrow = /** @type {(inputs: Landing_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What almost nobody knows yet`)
};

/**
* | output |
* | --- |
* | "What almost nobody knows yet" |
*
* @param {Landing_Law_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_eyebrow = /** @type {((inputs?: Landing_Law_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_eyebrow(inputs)
	if (locale === "en") return en_landing_law_eyebrow(inputs)
	return es_landing_law_eyebrow(inputs)
});